import api from "../services/api";

// Fire-and-forget funnel event logging; failures never surface to the user.
export const logEvent = (eventType, metadata = null) => {
  return api
    .post("/api/events", { event_type: eventType, metadata })
    .catch(() => {});
};
